module.exports = __webpack_public_path__ + "img/mc.961b11eb.jpg";